<template>
  <div class="global-params-container">
    <div class="section-title">基础参数设置</div>
    <form class="params-form">
      <!-- 项目名称 -->
      <div class="form-row" style="margin-bottom: 20px">
        <div class="form-item">
          <label class="form-label">项目名称</label>
          <input
            type="text"
            v-model="formData.projectName"
            placeholder="请输入项目名称"
            class="form-input"
            style="width: 50vw"
          />
        </div>
      </div>

      <!-- 计算期、建设期、运营期、正常年 -->
      <div class="form-row" style="margin-bottom: 20px">
        <div class="form-item form-item--inline">
          <label class="form-label">计算期(年)</label>
          <div class="number-input">
            <button
              type="button"
              class="number-input__btn"
              @click="decreaseNumber('calculationPeriod')"
            >
              -
            </button>
            <input
              type="text"
              class="number-input__input"
              v-model.number="formData.calculationPeriod"
              readonly
            />
            <button
              type="button"
              class="number-input__btn"
              @click="increaseNumber('calculationPeriod')"
            >
              +
            </button>
          </div>
        </div>

        <div class="form-item form-item--inline">
          <label class="form-label">建设期(年)</label>
          <div class="number-input">
            <button
              type="button"
              class="number-input__btn"
              @click="decreaseNumber('constructionPeriod')"
            >
              -
            </button>
            <input
              type="text"
              class="number-input__input"
              v-model.number="formData.constructionPeriod"
              readonly
            />
            <button
              type="button"
              class="number-input__btn"
              @click="increaseNumber('constructionPeriod')"
            >
              +
            </button>
          </div>
        </div>

        <div class="form-item form-item--inline">
          <label class="form-label">运营期(年)</label>
          <div class="number-input">
            <button
              type="button"
              class="number-input__btn"
              @click="decreaseNumber('operationPeriod')"
            >
              -
            </button>
            <input
              type="text"
              class="number-input__input"
              v-model.number="formData.operationPeriod"
              readonly
            />
            <button
              type="button"
              class="number-input__btn"
              @click="increaseNumber('operationPeriod')"
            >
              +
            </button>
          </div>
        </div>

        <div class="form-item form-item--inline">
          <label class="form-label">正常年</label>
          <select
            v-model.number="formData.normalYear"
            class="param-select"
            @change="handleNormalYearChange"
          >
            <option v-for="year in normalYearOptions" :key="year" :value="year">
              第{{ year }}期
            </option>
          </select>
        </div>

        <div class="form-item form-item--inline">
          <label class="form-label">基准收益率(%)</label>
          <div class="number-input">
            <button
              type="button"
              class="number-input__btn"
              @click="decreaseNumber('discountRate')"
            >
              -
            </button>
            <input
              type="text"
              class="number-input__input"
              v-model.number="formData.discountRate"
              readonly
            />
            <button
              type="button"
              class="number-input__btn"
              @click="increaseNumber('discountRate')"
            >
              +
            </button>
          </div>
        </div>
      </div>

      <!-- 运营负荷表格 -->
      <div>
        <div class="form-label1">运营负荷设置:</div>
        <div v-if="formData.calculationPeriod > 0" class="load-table-container">
          <!-- 三行作为一个整体循环 -->
          <div
            v-for="rowIndex in tableRows"
            :key="'group-' + rowIndex"
            class="table-row-group"
          >
            <!-- 计算期行 -->
            <div :key="'period-' + rowIndex" class="table-row">
              <div class="table-cell row-name-cell period-cell">计算期</div>
              <div
                v-for="col in 10"
                :key="'period-' + rowIndex + '-' + col"
                class="table-cell"
              >
                <span
                  v-if="(rowIndex - 1) * 10 + col <= formData.calculationPeriod"
                  >{{ (rowIndex - 1) * 10 + col }}</span
                >
                <span v-else>-</span>
              </div>
            </div>

            <!-- 工程阶段行 -->
            <div :key="'stage-' + rowIndex" class="table-row">
              <div class="table-cell row-name-cell stage-cell">项目阶段</div>
              <div
                v-for="col in 10"
                :key="'stage-' + rowIndex + '-' + col"
                class="table-cell"
              >
                <span
                  v-if="(rowIndex - 1) * 10 + col <= formData.calculationPeriod"
                >
                  <span
                    v-if="
                      (rowIndex - 1) * 10 + col <= formData.constructionPeriod
                    "
                    style="color: #409eff"
                    >建设期</span
                  >
                  <span v-else style="color: #67c23a">运营期</span>
                </span>
                <span v-else>-</span>
              </div>
            </div>

            <!-- 运营负荷行 -->
            <div :key="'load-' + rowIndex" class="table-row">
              <div class="table-cell row-name-cell load-cell">运营负荷</div>
              <div
                v-for="col in 10"
                :key="'load-' + rowIndex + '-' + col"
                class="table-cell load-cell"
              >
                <span
                  v-if="(rowIndex - 1) * 10 + col <= formData.calculationPeriod"
                >
                  <input
                    type="number"
                    v-model.number="loadData[(rowIndex - 1) * 10 + col]"
                    @input="validateLoad((rowIndex - 1) * 10 + col)"
                    class="load-input"
                    min="0"
                    max="100"
                    step="1"
                  />
                  <span class="percentage">%</span>
                </span>
                <span v-else>-</span>
              </div>
            </div>

            <!-- 添加组间分割线，最后一组不添加 -->
            <div
              v-if="rowIndex < tableRows"
              class="table-group-separator"
            ></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { zongmove, totalTable, callplan } from "@/utils/comp.js";
const defaultFormData = {
  projectName: "",
  calculationPeriod: 12,
  constructionPeriod: 1,
  operationPeriod: 11,
  normalYear: 0,
  discountRate: 10, // 基准收益率，默认10%
};

const defaultLastPeriods = {
  constructionPeriod: 1,
  operationPeriod: 11,
};

export default {
  data() {
    return {
      formData: {
        ...defaultFormData,
      },
      loadData: {},
      lastConstructionPeriod: defaultLastPeriods.constructionPeriod,
      lastOperationPeriod: defaultLastPeriods.operationPeriod,
      lastCalculationPeriod: defaultFormData.calculationPeriod,
    };
  },
  created() {},
  computed: {
    tableRows() {
      return Math.ceil(Math.min(this.formData.calculationPeriod, 30) / 10);
    },
    normalYearOptions() {
      const options = [];
      // 找到运营负荷达到100%的第一年
      let first100Year = 0;
      for (
        let year = this.formData.constructionPeriod + 1;
        year <= this.formData.calculationPeriod;
        year++
      ) {
        if (Number(this.loadData[year]) >= 100) {
          first100Year = year;
          break;
        }
      }
      // 如果没有达到100%的年份，则从运营期第一年开始
      if (first100Year === 0) {
        first100Year = this.formData.constructionPeriod + 1;
      }
      // 生成从first100Year到计算期结束的选项
      for (
        let year = first100Year;
        year <= this.formData.calculationPeriod;
        year++
      ) {
        options.push(year);
      }
      return options;
    },
    defaultNormalYear() {
      // 找到运营负荷达到100%的第一年作为默认值
      for (
        let year = this.formData.constructionPeriod + 1;
        year <= this.formData.calculationPeriod;
        year++
      ) {
        if (Number(this.loadData[year]) >= 100) {
          return year;
        }
      }
      // 如果没有达到100%的年份，则返回运营期第一年
      return this.formData.constructionPeriod + 1;
    },
  },
  methods: {
    getDefaultFormData() {
      return {
        ...defaultFormData,
      };
    },
    getDefaultLastPeriods() {
      return {
        ...defaultLastPeriods,
      };
    },
    decreaseNumber(field) {
      const minValues = {
        calculationPeriod: 1,
        constructionPeriod: 1,
        operationPeriod: 0,
        discountRate: 0,
      };

      if (this.formData[field] > minValues[field]) {
        this.formData[field]--;
        if (field === "calculationPeriod") {
          this.handleCalculationPeriodChange();
        } else if (
          field === "constructionPeriod" ||
          field === "operationPeriod"
        ) {
          this.handlePeriodChange();
        } else {
          this.updateVuexData();
          zongmove();
        }
      }
    },

    increaseNumber(field) {
      const maxValues = {
        calculationPeriod: 30,
        constructionPeriod: this.formData.calculationPeriod - 1,
        operationPeriod: this.formData.calculationPeriod - 1,
        discountRate: 100,
      };

      if (this.formData[field] < maxValues[field]) {
        this.formData[field]++;
        if (field === "calculationPeriod") {
          this.handleCalculationPeriodChange();
        } else if (
          field === "constructionPeriod" ||
          field === "operationPeriod"
        ) {
          this.handlePeriodChange();
        } else {
          this.updateVuexData();
        }
      }
    },

    validateLoad(year) {
      // 确保输入的数字在0-100之间（防止字符串或undefined）
      const val = Number(this.loadData[year]) || 0;
      this.loadData[year] = Math.min(100, Math.max(0, Math.round(val)));
    },

    // 统一处理建设期/运营期调整后对 loadData 的修正
    // 清理超出计算期范围的负荷数据
    cleanupLoadData() {
      // 创建新的loadData对象，只保留计算期内的数据
      const newLoadData = {};
      for (let year = 1; year <= this.formData.calculationPeriod; year++) {
        if (this.loadData[year] !== undefined) {
          newLoadData[year] = this.loadData[year];
        }
      }
      this.loadData = newLoadData;
    },

    normalizeLoadData() {
      for (let year = 1; year <= this.formData.calculationPeriod; year++) {
        if (year <= this.formData.constructionPeriod) {
          this.loadData[year] = 0;
        } else {
          if (
            this.loadData[year] === undefined ||
            Number(this.loadData[year]) === 0
          ) {
            this.loadData[year] = 100;
          } else {
            this.loadData[year] = Number(this.loadData[year]);
          }
        }
      }
    },

    handleCalculationPeriodChange() {
      const oldCalculationPeriod =
        this.lastCalculationPeriod || this.formData.calculationPeriod;

      this.formData.operationPeriod =
        this.formData.calculationPeriod - this.formData.constructionPeriod;
      if (this.formData.operationPeriod < 0) {
        this.formData.operationPeriod = 0;
      }

      this.cleanupLoadData();

      this.lastCalculationPeriod = this.formData.calculationPeriod;
      this.$store.commit("setIsProjectSaved", false);
    },

    handlePeriodChange() {
      const constructionChanged =
        this.formData.constructionPeriod !== this.lastConstructionPeriod;
      const operationChanged =
        this.formData.operationPeriod !== this.lastOperationPeriod;

      this.lastConstructionPeriod = this.formData.constructionPeriod;
      this.lastOperationPeriod = this.formData.operationPeriod;

      if (constructionChanged) {
        this.formData.operationPeriod =
          this.formData.calculationPeriod - this.formData.constructionPeriod;
        if (this.formData.operationPeriod < 0) {
          this.formData.operationPeriod = 0;
          this.formData.constructionPeriod = this.formData.calculationPeriod;
        }
      } else if (operationChanged) {
        this.formData.constructionPeriod =
          this.formData.calculationPeriod - this.formData.operationPeriod;
        if (this.formData.constructionPeriod < 0) {
          this.formData.constructionPeriod = 0;
          this.formData.operationPeriod = this.formData.calculationPeriod;
        }
      }

      this.lastConstructionPeriod = this.formData.constructionPeriod;
      this.lastOperationPeriod = this.formData.operationPeriod;

      this.updateVuexData();
      zongmove();
      callplan(0);
      this.cleanupLoadData();
      this.normalizeLoadData();
    },

    initLoadData() {
      const newLoadData = {};

      for (let year = 1; year <= this.formData.calculationPeriod; year++) {
        if (this.loadData[year] !== undefined) {
          newLoadData[year] = this.loadData[year];
        } else {
          if (year <= this.formData.constructionPeriod) {
            newLoadData[year] = 0;
          } else if (year === this.formData.constructionPeriod + 1) {
            newLoadData[year] = 70;
          } else if (year === this.formData.constructionPeriod + 2) {
            newLoadData[year] = 90;
          } else {
            newLoadData[year] = 100;
          }
        }
      }

      this.loadData = newLoadData;
    },

    handleNormalYearChange() {
      // 正常年变化时，更新Vuex数据
      this.updateVuexData();
      zongmove();
    },

    updateVuexData() {
      const currentData = this.$store.state.projectData || {};

      // 只更新基础数据，不覆盖其他组件的数据
      const updatedData = {
        ...currentData,
        jindexname: this.formData.projectName || currentData.jindexname,
        projectName: this.formData.projectName || currentData.projectName,
        基础数据: {
          ...currentData["基础数据"],
          ...this.formData,
          loadData: this.loadData,
        },
      };

      this.$store.commit("setProjectData", updatedData);

      // 设置项目已保存状态
      this.$store.commit("setIsProjectSaved", true);

      // 不需要在这里触发自动计算，因为setProjectData会处理
    },
  },

  mounted() {
    const projectData = this.$store.state.projectData;

    // 优先从公共数据获取基础数据，兼容旧数据结构
    const commonData = this.$store.state.commonData;
    const projectInfo = commonData.projectInfo || {};
    const basicData = projectData?.["基础数据"] || {};

    // 合并数据，公共数据优先
    const mergedBasicData = {
      ...basicData,
      ...projectInfo,
    };

    this.formData = {
      projectName: mergedBasicData.projectName || "",
      calculationPeriod: mergedBasicData.calculationPeriod || 12,
      constructionPeriod: mergedBasicData.constructionPeriod || 1,
      operationPeriod: mergedBasicData.operationPeriod || 11,
      normalYear: mergedBasicData.normalYear || 0,
      discountRate: mergedBasicData.discountRate || 10,
    };

    this.lastConstructionPeriod = this.formData.constructionPeriod;
    this.lastOperationPeriod = this.formData.operationPeriod;

    this.loadData = mergedBasicData.loadData || {};

    // 如果没有 loadData，则初始化默认负荷
    if (!this.loadData || Object.keys(this.loadData).length === 0) {
      this.initLoadData();
    }

    // 如果normalYear为0，自动设置为默认值
    if (this.formData.normalYear === 0) {
      this.formData.normalYear = this.defaultNormalYear;
    }

    // 初始化完成后，将数据同步到Vuex，但不触发自动计算，避免组件加载时的不必要计算
    this.$store.commit("setIsProjectSaved", true);
  },
  watch: {
    "$store.state.projectData": {
      handler(newVal) {
        if (newVal === null) {
          this.formData = this.getDefaultFormData();
          this.loadData = {};
          this.lastConstructionPeriod =
            this.getDefaultLastPeriods().constructionPeriod;
          this.lastOperationPeriod =
            this.getDefaultLastPeriods().operationPeriod;
          this.initLoadData();
        }
      },
      deep: true,
    },
    // 监听项目名称变化，自动更新Vuex
    "formData.projectName": {
      handler() {
        this.updateVuexData();
        zongmove();
      },
    },
    // 监听计算期变化，自动更新Vuex
    "formData.calculationPeriod": {
      handler(newVal) {
        this.lastCalculationPeriod = newVal;
        this.updateVuexData();
        zongmove();
      },
    },
    // 监听建设期变化，自动更新Vuex
    "formData.constructionPeriod": {
      handler() {
        this.updateVuexData();
      },
    },
    // 监听运营期变化，自动更新Vuex
    "formData.operationPeriod": {
      handler() {
        this.updateVuexData();
      },
    },
    // 监听loadData变化，自动更新Vuex
    loadData: {
      handler() {
        this.updateVuexData();
        zongmove(true);
        // 当loadData变化时，检查normalYear是否仍然有效
        if (!this.normalYearOptions.includes(this.formData.normalYear)) {
          // 如果当前normalYear不再有效，重新设置为默认值
          this.formData.normalYear = this.defaultNormalYear;
        }
      },
      deep: true,
    },
    // 监听正常年变化，自动更新Vuex
    "formData.normalYear": {
      handler() {
        this.updateVuexData();
        zongmove(false);
      },
    },
    // 监听基准收益率变化，自动更新Vuex
    "formData.discountRate": {
      handler() {
        this.updateVuexData();
        zongmove(false);
      },
    },
  },
};
</script>
<style scoped>
.global-params-container {
  height: 100%;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.params-form {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.form-item {
  display: flex;
  margin-bottom: 15px;
  justify-content: left;
  align-items: center;
}

.form-item--inline {
  flex-direction: row;
  align-items: center;
  margin-right: 15px;
}

.form-label {
  display: inline-block;
  width: 90px;
  font-weight: 500;
  color: #333;
  margin-bottom: 5px;
  font-size: 13px;
}

.form-item--inline .form-label {
  margin-bottom: 0;
  margin-right: 8px;
}

.form-input {
  height: 36px;
  padding: 0 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: #409eff;
}

/* 数字输入组件 */
.number-input {
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  /* width: 100px; */
}

.number-input--small {
  /* width: 85px; */
}

.number-input__btn {
  width: 28px;
  height: 36px;
  background-color: #f5f7fa;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.number-input--small .number-input__btn {
  width: 24px;
  height: 28px;
  font-size: 16px;
}

.number-input__btn:hover {
  background-color: #e4e7ed;
}

.number-input__input {
  /* flex: 1; */
  height: 36px;
  border: none;
  text-align: center;
  font-size: 14px;
  /* outline: none; */
  width: 40px;
}

.number-input--small .number-input__input {
  height: 28px;
  font-size: 13px;
  /* width: 40px; */
}

/* 正常年下拉框样式 */
.param-select {
  height: 36px;
  padding: 0 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  background-color: #fff;
  cursor: pointer;
  transition: border-color 0.2s;
  min-width: 80px;
}

.param-select:focus {
  outline: none;
  border-color: #409eff;
}

.param-select:hover {
  border-color: #c0c4cc;
}

/* 表格样式 */
.load-table-container {
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
}

/* 组间分割线 */
.table-group-separator {
  height: 10px;
  background-color: #dcdfe6;
  margin: 0;
  border-top: 1px solid #c0c4cc;
  border-bottom: 1px solid #c0c4cc;
}

.table-header-row,
.table-row {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #e6e6e6;
}

.table-row:last-child {
  border-bottom: none;
}

.table-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-right: 1px solid #e6e6e6;
  width: 8vw;
  height: 40px;
  box-sizing: border-box;
}

.table-cell:last-child {
  border-right: none;
}

.row-name-cell {
  width: 100px;
  background-color: #f5f7fa;
  font-weight: bold;
}

.period-cell,
.stage-cell {
  /* 继承row-name-cell的样式 */
}

.year-cell {
  background-color: #f5f7fa;
  font-weight: bold;
}

.load-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.load-input {
  width: 60px;
  height: 30px;
  text-align: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 5px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.load-input:focus {
  outline: none;
  border-color: #409eff;
}

.percentage {
  margin-left: 5px;
  color: #606266;
}

.form-input {
  /* width: 100px; */
  /* text-align: center; */
}

.form-label1 {
  width: 100%;
  text-align: left;
  padding-left: 15px;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 900;
}

.form-itembut {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

/* 按钮样式 */
.primary-btn {
  width: 200px;
  height: 36px;
  padding: 0 15px;
  background-color: #409eff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.primary-btn:hover {
  background-color: #66b1ff;
}
</style>
